<h1 class="text-center border-bottom pb-3">Importgeschiedenis — {{ areaName }}</h1>

<div
  *ngIf="!hasProductFactoryAccess"
  class="alert alert-warning mt-3"
>
  <h2 class="h5 mb-2">Alleen voor Product Factory</h2>
  <p class="mb-0">Raak deze pagina niet aan tenzij je onderdeel bent van het Product Factory-team (AWS-PF).</p>
</div>

<ng-container *ngIf="hasProductFactoryAccess">
  <div [ngClass]="{ 'd-none': feedbackSettings.show }">
    <div class="d-flex justify-content-between align-items-center px-1 py-3">
      <a
        class="btn btn-sm btn-outline-secondary"
        routerLink="/product-import/status"
      >
        &larr; Terug
      </a>
      <button
        class="btn btn-sm btn-outline-secondary"
        type="button"
        (click)="loadReports()"
        [disabled]="isLoading"
      >
        <span
          *ngIf="isLoading"
          class="spinner-border spinner-border-sm me-2"
        ></span>
        Vernieuwen
      </button>
    </div>

    <div
      *ngIf="!isLoading"
      class="table-responsive"
    >
      <p
        *ngIf="reports.length === 0"
        class="text-muted"
      >
        Geen rapporten gevonden voor dit gebied.
      </p>

      <table
        *ngIf="reports.length > 0"
        class="table table-striped table-sm align-middle"
      >
        <thead>
          <tr>
            <th scope="col">Boekdatum</th>
            <th scope="col">Run</th>
            <th scope="col">Status</th>
            <th
              scope="col"
              class="text-end"
            >
              Fouten
            </th>
            <th
              scope="col"
              class="text-end"
            >
              Waarsch.
            </th>
            <th
              scope="col"
              class="text-end"
            >
              Verwerkt
            </th>
            <th
              scope="col"
              class="text-end"
            >
              Aangemaakt
            </th>
            <th
              scope="col"
              class="text-end"
            >
              Bijgewerkt
            </th>
            <th
              scope="col"
              class="text-end"
            >
              Verwijderd
            </th>
            <th scope="col">Gestart</th>
            <th scope="col">Voltooid</th>
            <th scope="col">Rapport</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let report of reports">
            <td>{{ report.businessDate }}</td>
            <td>{{ report.runNumber }}</td>
            <td><span [ngClass]="statusBadgeClass(report)">{{ statusLabel(report) }}</span></td>
            <td
              class="text-end"
              [class.text-danger]="report.counts.errorCount > 0"
              [class.fw-bold]="report.counts.errorCount > 0"
            >
              {{ report.counts.errorCount }}
            </td>
            <td
              class="text-end"
              [class.text-warnings]="report.counts.warningCount > 0"
              [class.fw-bold]="report.counts.warningCount > 0"
            >
              {{ report.counts.warningCount }}
            </td>
            <td class="text-end">{{ report.counts.processed }}</td>
            <td class="text-end">{{ report.counts.created }}</td>
            <td class="text-end">{{ report.counts.updated }}</td>
            <td class="text-end">{{ report.counts.deleted }}</td>
            <td>{{ report.startedAt ? (report.startedAt | utcDate: 'dd-MM-yyyy HH:mm') : '-' }}</td>
            <td>{{ report.finishedAt ? (report.finishedAt | utcDate: 'dd-MM-yyyy HH:mm') : '-' }}</td>
            <td>
              <a
                *ngIf="report.reportUrl"
                [href]="report.reportUrl"
                target="_blank"
                rel="noopener"
              >
                Rapport
              </a>
              <span
                *ngIf="!report.reportUrl"
                class="text-muted"
                >—</span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-container>

<div
  class="d-flex justify-content-center feedback_box"
  [ngClass]="{
    'd-none': !feedbackSettings.show,
  }"
>
  <app-feedback
    [(settings)]="feedbackSettings"
    (update)="returnHome()"
  ></app-feedback>
</div>

<div [ngClass]="{ 'd-none': !isLoading }">
  <app-loading-gears></app-loading-gears>
</div>
